import { useEffect, type PropsWithChildren } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { selectIsAuthenticated } from './selectors';
import { openAccountModal } from './accountModalSlice';

export function AccountGuard({ children }: PropsWithChildren) {
  const isAuthed = useAppSelector(selectIsAuthenticated);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { restaurantUuid } = useParams<{ restaurantUuid: string }>();

  useEffect(() => {
    if (isAuthed) return;
    dispatch(openAccountModal({
      mode: 'login',
      redirectTo: location.pathname + location.search,
    }));
    navigate(`/${restaurantUuid}`, { replace: true });
  }, [isAuthed, dispatch, location.pathname, location.search, navigate, restaurantUuid]);

  if (!isAuthed) return null;
  return <>{children}</>;
}
